export interface IUserProfileData {
  id: string;
  fullName: string;
  email: string;
  phoneNumber: string | null;
  phoneExtension: number | null;
  pronouns: string;
  timeZone: string;
  notes: string;
  languages: string[];
  workSchedule: Partial<Record<eWeekdays, IAdminWorkSchedule>>;
}

export interface IAdminWorkSchedule {
  startTime?: string;
  endTime?: string;
}

export enum eWeekdays {
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
}

export const prettyWeekDays: Record<eWeekdays, string> = {
  [eWeekdays.Monday]: 'Monday',
  [eWeekdays.Tuesday]: 'Tuesday',
  [eWeekdays.Wednesday]: 'Wednesday',
  [eWeekdays.Thursday]: 'Thursday',
  [eWeekdays.Friday]: 'Friday',
  [eWeekdays.Saturday]: 'Saturday',
  [eWeekdays.Sunday]: 'Sunday',
};

export type IUserProfileResponse = IUserProfileData;

export const convertFromIUserProfileResponseToIUserProfileData = (data: IUserProfileResponse): IUserProfileData => data;

export const convertFromIUserProfileDataToIUserProfileResponse = (data: IUserProfileData): IUserProfileResponse => data;
